

define(['angular', 'squid/index', 'text!./template.html', '../directive', '../props', 'components/xo-beaver/dist/logger', 'components/xo-models/src/checkout/index', 'components/xo-models/src/app/index', 'components/xo-ui-components/src/message/directive', 'components/xo-title/dist/directive', 'components/xo-form-components/src/language-options/directive', 'unified-login/directive', 'components/xo-device-info/dist/index'], function (angular, squid, template) {

    return angular.module('xo-login-handler.directive', ['squid', 'beaver', 'xomodel.checkout', 'xomodel.app', 'xo-message.directive', 'xo-title.directive', 'xo-login.directive', 'xo-language-options.directive', 'xo-unified-login.directive', 'xo-login-props', 'xo-device-info']).directive('xoLoginHandler', function ($util, $pxp, $logger, $locale, $loginProps) {

        return {

            componentize: true,

            template: template,

            scope: {
                token: '=',
                successCallback: '=',
                contingencyCallback: '=',
                autoLogin: '=',
                ulEligibility: '=',
                subFlowTitleKey: '=',
                apsIntegration: '=',
                batch: '=',
                loginSubmit: '=',
                logout: '=',
                preAuth: '=',
                hideloginpp: '=',
                flowcontext: '='
            },

            controller: function controller($scope, $rootScope, $populate, $window, $location, $state, $AuthModel, $feature, $AppDataModel, $CheckoutCartModel, $loginProps, // eslint-disable-line no-shadow
            $config, $logger, // eslint-disable-line no-shadow
            $timeout, $util, // eslint-disable-line no-shadow
            $localeHelper, $stateParams, $FallbackError) {

                // Login Contingency Handling
                var CONTENT_KEY = {
                    INVALID_EMAIL_PASSWORD: 'invalidEmailPasswordPageError',
                    ACCOUNT_LOCKED: 'accountLockedPageError',
                    ACCOUNT_CLOSED: 'accountLockedPageError',
                    INVALID_PHONE: 'invalidPhone',
                    INVALID_PIN: 'invalidPin',
                    INVALID_ACCESS_TOKEN: 'invalidAccessToken',
                    TIMED_OUT: 'loginStatusTimedOut',
                    CANNOT_PAY_SELF: 'cannotPaySelf',
                    RISK_DECLINE: 'riskDeclinePageError',
                    LOGIN_ADD_PHONE: 'loginAddPhone',
                    LOGIN_PREFILLED_SHIPPING_ADDRESS: 'loginMerchantPassedAddress',
                    LOGIN_CONTINGENCY: 'loginContingency',
                    LOGIN_REACTIVATE: 'checkOneTouch',
                    LOGIN_LEAVECHECKED: 'leaveOneTouchChecked',
                    LOGIN_OT_GENERIC_ERROR: 'reactivateOneTouch'
                };

                var CONTENT_MAPPING = {
                    INVALID_USER: { content: CONTENT_KEY.INVALID_EMAIL_PASSWORD, type: 'error' },
                    INVALID_PHONE_PIN: { content: CONTENT_KEY.INVALID_PIN, type: 'error' },
                    INVALID_ACCESS_TOKEN: { content: CONTENT_KEY.INVALID_ACCESS_TOKEN, type: 'error' },
                    LOCKED_USER: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                    ACCOUNT_LOCKED: { content: CONTENT_KEY.ACCOUNT_LOCKED, type: 'error' },
                    CLOSED_USER: { content: CONTENT_KEY.ACCOUNT_CLOSED, type: 'error' },
                    TIMED_OUT: { content: CONTENT_KEY.TIMED_OUT, type: 'error' },
                    CANNOT_PAY_SELF: { content: CONTENT_KEY.CANNOT_PAY_SELF, type: 'error' },
                    RISK_DECLINE: { content: CONTENT_KEY.RISK_DECLINE, type: 'error' },
                    addPhone: { content: CONTENT_KEY.LOGIN_ADD_PHONE, type: 'error' },
                    PAYER_AUTHENTICATION_REQUIRED: {
                        content: CONTENT_KEY.LOGIN_PREFILLED_SHIPPING_ADDRESS,
                        type: 'info'
                    },
                    LOGIN_CONTINGENCY: { content: CONTENT_KEY.LOGIN_CONTINGENCY, type: 'error' },
                    ONETOUCH_REACTIVATE: { content: CONTENT_KEY.LOGIN_REACTIVATE, type: 'warning' },
                    ONETOUCH_LEAVECHECKED: { content: CONTENT_KEY.LOGIN_LEAVECHECKED, type: 'warning' },
                    ONETOUCH_GENERIC_ERROR: { content: CONTENT_KEY.LOGIN_OT_GENERIC_ERROR, type: 'warning' }
                };

                function populateMessage(name, type) {
                    var contentKey = CONTENT_MAPPING[name];
                    if (contentKey) {
                        $scope.message = {
                            msgKeys: ['login.' + contentKey.content],
                            type: type || contentKey.type
                        };
                    } else {
                        $logger.debug('unresolved content for login ' + type + ' message ' + name + ' in xo-login page');
                    }
                }

                function handleAuthChallengeFailure(urlParams) {
                    if (urlParams.acRedirect === '2fa') {
                        var userLocale = urlParams['locale.test'];

                        if (userLocale) {
                            $locale.chosenLang = $localeHelper.normalizeLocale(userLocale).language;
                        }

                        if (urlParams.ulMethod === 'phone') {
                            $logger.debug('2FA_RETURNED_FAILED_PHONE');
                            populateMessage('INVALID_PHONE_PIN', 'error');
                        } else {
                            $logger.debug('2FA_RETURNED_FAILED_EMAIL');
                            populateMessage('INVALID_USER', 'error');
                        }
                    } else if (urlParams.acRedirect === 'loginato') {
                        $logger.debug('LOGIN_ATO_RETURNED_FAILED');
                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                    } else if (urlParams.acRedirect === 'safe') {
                        $logger.debug('SAFE_RETURNED_FAILED');
                        $state.go('checkout.genericError', { code: 'RESTRICTED_USER' });
                    }
                }

                function handleAuthChallengeSuccess(urlParams) {
                    switch (urlParams.acRedirect) {
                        case '2fa':
                            $logger.debug('2FA_RETURNED_SUCCESS');
                            break;
                        case 'loginato':
                            $logger.debug('LOGIN_ATO_RETURNED_SUCCESS');
                            break;
                        case 'safe':
                            $logger.debug('SAFE_RETURNED_SUCCESS');
                            break;
                        default:
                        // do nothing
                    }
                    $scope.auth.is_auth_api_call = !urlParams.acRedirect;
                }

                $scope.onComplete = function (auth) {
                    // Dont show the login contingency message once poma password recovery is enabled.
                    if (!$feature('pomaPasswordRecovery') && $scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        populateMessage('LOGIN_CONTINGENCY', 'info');
                    }

                    if ($rootScope.contingency && $rootScope.contingency.message) {
                        populateMessage($rootScope.contingency.message, 'error');
                    } else {
                        $locale.choose(auth.country, auth.language, false);
                        $scope.successCallback();
                    }
                };

                // Make country and lang available to htmlContent for dynamically generating content
                $scope.locale = $locale;

                if ($stateParams.targetPage) {
                    if ($loginProps.inList($stateParams.targetPage) && $feature('riskyLoginContingency')) {
                        var riskyLoginInfo = $loginProps.mapInfo($stateParams.targetPage);
                        $scope.subFlowTitleKey = riskyLoginInfo.title;
                        $scope.contingencyDesc = riskyLoginInfo.subtitle;
                        $scope.hideloginpp = true;
                        $scope.postlogout = function () {
                            delete $scope.subFlowTitleKey;

                            if ($scope.contingencyDesc) {
                                delete $scope.contingencyDesc;
                            }

                            delete $scope.hideloginpp;
                            $scope.showLanguageDropdown = $feature('languageToggle');
                            $scope.logout();
                        };
                    } else {
                        var errMessage = CONTENT_MAPPING[$stateParams.targetPage] ? $stateParams.targetPage : 'LOGIN_CONTINGENCY';
                        var type = errMessage.type ? errMessage.type : 'info';
                        populateMessage(errMessage, type);
                    }
                }

                if ($AuthModel.instance().meta.invalidated) {
                    populateMessage('TIMED_OUT', 'error');
                } else if ($AuthModel.instance().meta.selfPay) {
                    populateMessage('CANNOT_PAY_SELF', 'error');
                    $AuthModel.instance().meta.selfPay = false;
                }

                $populate($scope, {
                    auth: $AuthModel.instance(),
                    checkoutCart: $CheckoutCartModel.instance($scope.token).retrieve()
                }).then(function () {
                    // Land on create password info page in case poma user was routed to login, after the
                    // initial login/auth.
                    if ($feature('pomaPasswordRecovery') && $scope.auth.password_less && !$scope.autoLogin) {
                        $state.go('checkout.createPassword', { targetPage: $stateParams.targetPage });
                        return;
                    }

                    var ULCallbacks = {
                        showErrorMessages: function showErrorMessages(errorCase) {
                            populateMessage(errorCase);
                            $timeout(function () {
                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                            });
                        },
                        toggleUnifiedLogin: function toggleUnifiedLogin(value) {
                            $scope.ulEligibility = value;
                            $scope.apsIntegration = true;
                            $rootScope.continueLoadingForUL = value;
                            $timeout(function () {
                                $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                            });
                        }
                    };

                    $scope.ULCallback = function (name, value) {
                        var callback = ULCallbacks[name];
                        if (callback) {
                            callback(value);
                        }
                    };

                    if ($scope.auth.timed_out) {
                        populateMessage('TIMED_OUT', 'error');
                    }

                    if (!$scope.subFlowTitleKey) {
                        $scope.showLanguageDropdown = $feature('languageToggle');
                    }

                    var urlParams = $util.params();

                    if (urlParams.acRedirect) {
                        // Returning from auth challenge
                        if (urlParams.failedBecause) {
                            handleAuthChallengeFailure(urlParams);
                        } else {
                            handleAuthChallengeSuccess(urlParams);
                        }
                    }

                    var handleContingency = {
                        // Errors - Show Page Level Error
                        INVALID_USER: populateMessage,
                        LOCKED_USER: populateMessage,
                        ACCOUNT_LOCKED: populateMessage,
                        CLOSED_USER: populateMessage,
                        ONETOUCH_REACTIVATE: populateMessage,
                        ONETOUCH_LEAVECHECKED: populateMessage

                    };

                    $scope.onContingency = function (name, contingency, type) {
                        // eslint-disable-line no-shadow

                        $locale.choose($scope.auth.country, $scope.auth.language, false);

                        if (!handleContingency[name]) {
                            return $scope.contingencyCallback(name, contingency);
                        }

                        var message_type = type || 'error';
                        return handleContingency[name](name, message_type);
                    };
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/login/handler/directive.js
// module id = ./components/xo-login-components/src/login/handler/directive.js
// module chunks = 1